import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div`

  > :not(:last-child) {
     margin-bottom: 21px;
  }
  ${(props) => (props.canUpdate ? '' : 'pointer-events: none')}
`;

Wrapper.displayName = 'Wrapper';

export const NoFieldsText = styled.span`
  font-size: 12.5px;
  line-height: 1.76;
  color: ${colors.grey19};
  ${(props) => (props.canUpdate ? '' : 'user-select: none')}
`;

NoFieldsText.displayName = 'NoFieldsText';
